import React, { useRef, useState } from "react";
import {
  Button as Button2,
  DownloadButton,
  Modal,
} from "../../../../components/core";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import { formatDateTime } from "../../../../algorithms/date";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useMutation } from "@apollo/client";
import {
  DELETE_SUPICIOUS_NUMBER_BY_AGENT,
  UPSERT_SUSPICIOUS_NUM_BY_AGENT_ID,
} from "../../../../constants/graphql/suspicious-numbers-per-agent-queries";
import { Strings } from "../../../../constants/strings";
import TotalRecords from "../../../../components/core/total-records";

const SuspisciousNumbersPerAgent = ({
  open,
  onHide,
  suspiciousData,
  accessPermission,
  setLoading,
  isLoading,
  isOnAgentProfile,
}) => {
  const [editSupiciousNubmer, setEditNumber] = useState({
    visibility: false,
    newNumber: "",
    oldNumber: "",
    partnerAgentSuspiciousMobileId: "",
  });
  const [addSuspiciousNum, setAddSuspiciousNum] = useState({
    visibility: false,
    newNumber: "",
  });
  const dt = useRef(null);

  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  // mutation gql
  const [upsertSuspiciousNumber] = useMutation(
    UPSERT_SUSPICIOUS_NUM_BY_AGENT_ID
  );
  const [deleteSuspiciousNumber] = useMutation(
    DELETE_SUPICIOUS_NUMBER_BY_AGENT
  );

  const validateFields = () => {
    const numberString = editSupiciousNubmer.newNumber;

    // Check if it's a valid Philippine mobile number (639 + 9 digits)
    if (
      !numberString ||
      numberString.length !== 12 ||
      !numberString.startsWith("639") ||
      !/^639\d{9}$/.test(numberString)
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message: "Invalid mobile number. Please recheck.",
        open: true,
        actions: (
          <div className="w-full">
            <Button2
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      handleSaveChanges(true);
    }
  };

  const buildVariables = (isEditing) => {
    const baseVariables = {
      input: {
        partnerAgentId: suspiciousData.agentId,
        agentMobile: isEditing
          ? editSupiciousNubmer.newNumber
          : addSuspiciousNum.newNumber,
      },
    };

    // Only add partnerAgentSuspiciousMobileId if it exists (for updates)
    if (isEditing) {
      if (
        editSupiciousNubmer.partnerAgentSuspiciousMobileId &&
        editSupiciousNubmer.partnerAgentSuspiciousMobileId !== ""
      ) {
        baseVariables.partnerAgentSuspiciousMobileId =
          editSupiciousNubmer.partnerAgentSuspiciousMobileId;
      }
    }

    return baseVariables;
  };

  const handleSaveChanges = (isEditing = false) => {
    const variables = buildVariables(isEditing);

    upsertSuspiciousNumber({
      variables: variables,
    })
      .then((r) => {
        if (r.data) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: isEditing
              ? Strings.popup_success_message_edit
              : Strings.popup_success_message_add,
            open: true,
            actions: (
              <div className="w-full">
                <Button2
                  onClick={() => {
                    setValidation({ open: false });
                    window.location.reload();
                  }}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      })
      .catch((e) => {
        if (e.message.includes("already exists for this agent")) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title_duplicate,
            message: Strings.popup_number_exists,
            open: true,
            actions: (
              <div className="w-full">
                <Button2
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        } else {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_edit,
            open: true,
            actions: (
              <div className="w-full">
                <Button2
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      });
  };

  const handleDelete = (rowData) => {
    deleteSuspiciousNumber({
      variables: {
        partnerAgentSuspiciousMobileId: rowData.partnerAgentSuspiciousMobileId,
      },
    })
      .then((r) => {
        if (r.data) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: Strings.popup_success_message_remove,
            open: true,
            actions: (
              <div className="w-full">
                <Button2
                  onClick={() => {
                    setValidation({ open: false });
                    window.location.reload();
                  }}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      })
      .catch((e) => {
        if (e) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_remove,
            open: true,
            actions: (
              <div className="w-full">
                <Button2
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      });
  };

  return (
    <>
      <Dialog
        visible={open}
        draggable={false}
        resizable={false}
        className="max-w-[95%] md:w-[950px]"  
        // headerClassName="p-1 m-0"
        onHide={onHide}
        header="Suspicious Numbers"
      >
        <div>
          {isOnAgentProfile && (
            <i>
              To add a suspicious number, please click{" "}
              <a
                href="/operator/admin/suspicious-courier-numbers"
                target="_blank"
                className="text-component-underlineBlue"
              >
                here
              </a>
            </i>
          )}
          <div className="pb-3 text-lg pt-6">
            Agent Name:{" "}
            <span className="font-semibold">
              {suspiciousData?.firstName} {suspiciousData?.lastName}
            </span>
          </div>

          {!isOnAgentProfile && (
            <div className="w-full justify-between flex pb-5">
              <div></div>
              <Button2
                value={"ADD"}
                className={`w-40 h-8 bg-primary-primaryYellow shadow-md ${
                  accessPermission.suspiciousCourierTagging === 1 ||
                  accessPermission.suspiciousCourierTagging === "1"
                    ? "hidden"
                    : ""
                }`}
                onClick={() => {
                  setAddSuspiciousNum({
                    ...addSuspiciousNum,
                    visibility: true,
                  });
                }}
              ></Button2>
            </div>
          )}

          <div className="">
            <TotalRecords
              count={
                isOnAgentProfile
                  ? suspiciousData.suspiciousMobiles?.length
                  : suspiciousData.relatedNumbers?.length
              }
            />
            <DownloadButton dt={dt} csvOnly={true} />
          </div>
          <DataTable
            value={
              isOnAgentProfile
                ? suspiciousData.suspiciousMobiles
                : suspiciousData.relatedNumbers
            }
            ref={dt}
            exportFilename={`Suspicious Number - ${suspiciousData?.lastName}`}
            paginatorPosition="bottom"
            paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="Rows per page"
            // currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records |  Rows per page"
            paginator
            // paginatorRight
            rowsPerPageOptions={[10, 20]}
            rows={10}
            stripedRows
            className="max-h-[650px] h-[750px]"
          >
            <Column
              header="Mobile Number"
              headerClassName="bg-primary-primaryYellow"
              field="agentMobile"
            />
            <Column
              header="Created At"
              sortable
              headerClassName="bg-primary-primaryYellow"
              field="createdAt"
              body={(rowData) => <div>{formatDateTime(rowData.createdAt)}</div>}
            />
            <Column
              header="Updated At"
              sortable
              headerClassName="bg-primary-primaryYellow"
              field="updatedAt"
              body={(rowData) => <div>{formatDateTime(rowData.updatedAt)}</div>}
            />
            {!isOnAgentProfile && (
              <Column
                header={""}
                headerClassName="bg-primary-primaryYellow"
                body={(rowData) => {
                  return (
                    <div
                      className={`flex flex-row gap-2 w-min  ${
                        accessPermission.suspiciousCourierTagging === 1 ||
                        accessPermission.suspiciousCourierTagging === "1"
                          ? "hidden"
                          : ""
                      }`}
                    >
                      <Button
                        size="small"
                        icon="pi pi-pencil"
                        className="flex items-center bg-yellow-500 text-white border-0 p-[1px] py-[10px]"
                        onClick={() => {
                          setLoading(true);
                          setEditNumber({
                            visibility: true,
                            oldNumber: rowData.agentMobile,
                            partnerAgentSuspiciousMobileId:
                              rowData.partnerAgentSuspiciousMobileId,
                          });
                          setLoading(false);
                        }}
                        disabled={isLoading}
                      />

                      <Button
                        size="small"
                        icon="pi pi-trash"
                        className="flex items-center bg-red-500 text-white border-0 p-[1px] py-[10px]"
                        onClick={() => {
                          setValidation({
                            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                            title: "Delete Suspicious Number",
                            message: "Do you want to remove this number?",
                            open: true,
                            actions: (
                              <div className="grid grid-cols-2 gap-2">
                                <Button2
                                  onClick={() => {
                                    setValidation((prev) => ({
                                      ...prev,
                                      open: false,
                                    }));
                                  }}
                                  value={"No"}
                                  className={"p-2"}
                                />
                                <Button2
                                  onClick={() => {
                                    handleDelete(rowData);
                                    setValidation((prev) => ({
                                      ...prev,
                                      open: false,
                                    }));
                                  }}
                                  value={"Yes"}
                                  className={"p-2"}
                                />
                              </div>
                            ),
                          });
                        }}
                        disabled={isLoading}
                      />
                    </div>
                  );
                }}
              ></Column>
            )}
          </DataTable>
        </div>
      </Dialog>

      <Dialog
        visible={editSupiciousNubmer.visibility}
        onHide={() => {
          setEditNumber({
            visibility: false,
            newNumber: "",
            oldNumber: "",
          });
        }}
        header="Edit Mobile Number"
        className="w-[550px]"
        draggable={false}
        resizable={false}
        closable={false}
        footer={
          <>
            <div className="flex flex-col items-center justify-center p-2">
              <div className="flex gap-4">
                <div className="col-span-2"></div>
                <Button2
                  className={"p-2 bg-white border border-primary-primaryYellow"}
                  value={"Cancel"}
                  onClick={() => {
                    setEditNumber({
                      ...editSupiciousNubmer,
                      visibility: false,
                      newNumber: "",
                    });
                  }}
                />
                <Button2
                  className={"p-2 "}
                  value={"Save Changes"}
                  disabled={!editSupiciousNubmer.newNumber}
                  onClick={() => validateFields()}
                />
              </div>
            </div>
          </>
        }
      >
        <div className="grid grid-cols-5 items-center gap-4">
          <div className="col-span-2">Old Mobile Number:</div>
          <div className="col-span-3">{editSupiciousNubmer.oldNumber}</div>

          <div className="col-span-2">New Mobile Number:</div>
          <div>
            <InputText
              keyfilter={"int"}
              value={editSupiciousNubmer.newNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // If user tries to delete the 639 prefix, restore it
                  if (value.length < 3 || !value.startsWith("639")) {
                    setEditNumber((prev) => ({
                      ...prev,
                      newNumber: "639",
                    }));
                  } else {
                    setEditNumber((prev) => ({
                      ...prev,
                      newNumber: value,
                    }));
                  }
                }
              }}
              onFocus={(e) => {
                // Auto-add 639 when input is focused if empty or doesn't start with 639
                if (
                  !editSupiciousNubmer.newNumber ||
                  !editSupiciousNubmer.newNumber.startsWith("639")
                ) {
                  setEditNumber((prev) => ({
                    ...prev,
                    newNumber: "639",
                  }));
                }
                // Position cursor after 639
                setTimeout(() => {
                  e.target.setSelectionRange(3, 3);
                }, 0);
              }}
              maxLength={12}
              placeholder="Enter New Mobile Number"
              className="appearance-none col-span-3"
              pt={{
                root: {
                  className: "border border-gray-200 p-1 h-10 rounded-md",
                },
              }}
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={addSuspiciousNum.visibility}
        onHide={() => {
          setAddSuspiciousNum({
            visibility: false,
            newNumber: "",
          });
        }}
        header="Add Mobile Number"
        className="w-[550px]"
        draggable={false}
        resizable={false}
        closable={false}
        footer={
          <>
            <div className="flex flex-col items-center justify-center p-2">
              <div className="flex gap-4">
                <div className="col-span-2"></div>
                <Button2
                  className={"p-2 bg-white border border-primary-primaryYellow"}
                  value={"Cancel"}
                  onClick={() => {
                    setAddSuspiciousNum({
                      ...addSuspiciousNum,
                      visibility: false,
                      newNumber: "",
                    });
                  }}
                />
                <Button2
                  className={"p-2 "}
                  value={"Save Changes"}
                  disabled={!addSuspiciousNum.newNumber}
                  onClick={() => handleSaveChanges(false)}
                />
              </div>
            </div>
          </>
        }
      >
        <div className="grid grid-cols-5 items-center gap-4 pt-2">
          <div className="col-span-2">Enter Mobile Number:</div>
          <div>
            <InputText
              keyfilter={"int"}
              value={addSuspiciousNum.newNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  // If user tries to delete the 639 prefix, restore it
                  if (value.length < 3 || !value.startsWith("639")) {
                    setAddSuspiciousNum((prev) => ({
                      ...prev,
                      newNumber: "639",
                    }));
                  } else {
                    setAddSuspiciousNum((prev) => ({
                      ...prev,
                      newNumber: value,
                    }));
                  }
                }
              }}
              onFocus={(e) => {
                // Auto-add 639 when input is focused if empty or doesn't start with 639
                if (
                  !addSuspiciousNum.newNumber ||
                  !addSuspiciousNum.newNumber.startsWith("639")
                ) {
                  setAddSuspiciousNum((prev) => ({
                    ...prev,
                    newNumber: "639",
                  }));
                }
                // Position cursor after 639
                setTimeout(() => {
                  e.target.setSelectionRange(3, 3);
                }, 0);
              }}
              maxLength={12}
              placeholder="Enter Mobile Number"
              className="appearance-none col-span-3"
              pt={{
                root: {
                  className: "border border-gray-200 p-1 h-10 rounded-md",
                },
              }}
            />
          </div>
        </div>
      </Dialog>

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
};

export default SuspisciousNumbersPerAgent;
